import { getAdjustedMonthNumber } from "./mesAjustado";
function obtenerDatosTorta(data, mesesSeleccionados) {
	const secciones = ["Diurno", "Nocturno", "Madrugada"];
	const totalesNE = { Diurno: 0, Nocturno: 0, Madrugada: 0 };
	const totalesSP = { Diurno: 0, Nocturno: 0, Madrugada: 0 };

	const outputPlanningMonthlyArray = data[0]?.output_planning_monthly || [];

	secciones.forEach((seccion) => {
		if (data[0]?.contrato_monthly?.[seccion]) {
			data[0].contrato_monthly[seccion].forEach((item) => {
				const mesContrato = obtenerMesContrato(
					item.output_planning_monthly,
					outputPlanningMonthlyArray,
				);

				if (mesContrato && mesesSeleccionados.includes(mesContrato)) {
					totalesNE[seccion] += item.contratados_ne || 0;
					totalesSP[seccion] += item.contratados_sp || 0;
				}
			});
		}
	});

	return {
		datosTortaNE: secciones.map((seccion) => ({
			seccion,
			valor: totalesNE[seccion] || 0,
		})),
		datosTortaSP: secciones.map((seccion) => ({
			seccion,
			valor: totalesSP[seccion] || 0,
		})),
	};
}

function obtenerDatosBarras(data, mesesSeleccionados) {
	const secciones = ["Diurno", "Nocturno", "Madrugada"];
	const datosBarras = {};

	const outputPlanningMonthlyArray = data[0]?.output_planning_monthly || [];

	secciones.forEach((seccion) => {
		const contratos = data[0]?.contrato_monthly?.[seccion] || [];
		const agrupados = {};

		contratos.forEach((item) => {
			const mesContrato = obtenerMesContrato(item.output_planning_monthly, outputPlanningMonthlyArray);

			if (mesContrato && mesesSeleccionados.includes(mesContrato)) {
				const nombre = item.nombre_contrato;
				if (!agrupados[nombre]) {
					agrupados[nombre] = { contratados_sp: 0, contratados_ne: 0 };
				}
				agrupados[nombre].contratados_sp += item.contratados_sp || 0;
				agrupados[nombre].contratados_ne += item.contratados_ne || 0;
			}
		});

		datosBarras[seccion] = Object.keys(agrupados).map((nombre) => {
			const sp = agrupados[nombre].contratados_sp;
			const ne = agrupados[nombre].contratados_ne;
			const diferencia = ne - sp;
			return {
				nombre,
				contratados_sp: sp,
				contratados_ne: ne,
				diferencia,
			};
		});
	});

	secciones.forEach((seccion) => {
		if (!datosBarras[seccion]) {
			datosBarras[seccion] = [];
		}
	});

	return datosBarras;
}

function obtenerMesContrato(idOutputPlanningMonthly, outputPlanningMonthlyArray) {
	const output = outputPlanningMonthlyArray.find((item) => item.id === idOutputPlanningMonthly);
	if (!output) return null;
	// formateamos siempre como string "YYYY-MM"
	const yyyy = output.anno; // año
	const mm = String(output.mes).padStart(2, "0"); // mes con dos dígitos
	return `${yyyy}-${mm}`; // e.g. "2025-11"
}

function obtenerDiferencias(data, mesesSeleccionados) {
	const secciones = ["Diurno", "Nocturno", "Madrugada"];
	const diferencias = {};

	secciones.forEach((seccion) => {
		const contratos = data[0]?.contrato_monthly?.[seccion] || [];
		let totalSP = 0;
		let totalNE = 0;

		contratos.forEach((item) => {
			const mesContrato = obtenerMesContrato(
				item.output_planning_monthly,
				data[0].output_planning_monthly,
			);

			if (mesContrato && mesesSeleccionados.includes(mesContrato)) {
				totalSP += item.contratados_sp || 0;
				totalNE += item.contratados_ne || 0;
			}
		});

		diferencias[seccion] = totalSP === 0 && totalNE === 0 ? null : totalNE - totalSP;
	});

	return diferencias;
}

function obtenerLogrado(data, mesesSeleccionados) {
	const secciones = ["Diurno", "Nocturno", "Madrugada"];
	const logrado = {};

	secciones.forEach((seccion) => {
		const contratos = data[0].contrato_monthly[seccion] || [];
		let totalSP = 0;
		let zcero = 0;

		contratos.forEach((item) => {
			const mesContrato = obtenerMesContrato(
				item.output_planning_monthly,
				data[0].output_planning_monthly,
			);

			if (mesContrato && mesesSeleccionados.includes(mesContrato)) {
				totalSP += item.contratados_sp || 0;
				zcero += parseInt(item.z_cero, 10) || 0;
			}
		});

		logrado[seccion] = totalSP === 0 && zcero === 0 ? null : zcero - totalSP;
	});

	return logrado;
}

function obtenerDatosTabla(data, mesesSeleccionados) {
	if (!data || data.length === 0) return [];
	const secciones = ["Diurno", "Nocturno", "Madrugada"];
	const rows = [];

	const outputPlanningMonthlyArray = data[0].output_planning_monthly;

	secciones.forEach((seccion) => {
		const contratos = data[0].contrato_monthly[seccion] || [];

		contratos.forEach((item) => {
			const mesContrato = obtenerMesContrato(item.output_planning_monthly, outputPlanningMonthlyArray);

			if (mesContrato && mesesSeleccionados.includes(mesContrato)) {
				const nombre = item.nombre_contrato;
				const kronos_name = item.kronos_name || "";
				const mes = mesContrato;
				const contratados_ne = item.contratados_ne || 0;
				const contratados_sp = item.contratados_sp || 0;
				const diferencia = contratados_ne - contratados_sp;
				const zcero = parseInt(item.z_cero, 10);
				const logrado = zcero - contratados_sp;
				const seccion = item.tipo_contrato;

				rows.push({
					id: item.id,
					nombre,
					kronos_name,
					mes,
					contratados_ne,
					contratados_sp,
					diferencia,
					zcero,
					logrado,
					seccion,
				});
			}
		});
	});

	return rows;
}

function obtenerDatosLinea(data, mesesSeleccionados) {
	data.forEach((item) => {
		let date = new Date(item.fecha.slice(0, 10));
		item.adjustedMes = getAdjustedMonthNumber(date);
	});

	const datosFiltrados = data.filter((item) => mesesSeleccionados.includes(item.adjustedMes));

	const coberturaPorDia = datosFiltrados.reduce((acc, curr) => {
		const fecha = curr.fecha.slice(0, 10);
		const cobertura = curr.cobertura;

		if (!acc[fecha]) {
			acc[fecha] = { sumaCobertura: 0, conteoHoras: 0 };
		}

		acc[fecha].sumaCobertura += cobertura;
		acc[fecha].conteoHoras += 1;

		return acc;
	}, {});

	return Object.entries(coberturaPorDia).map(([fecha, { sumaCobertura, conteoHoras }]) => ({
		fecha,
		cobertura: (sumaCobertura / conteoHoras) * 100,
	}));
}

const obtenerDatosLineaFecha = (data, fechaInicio, fechaFin) => {
	const coberturaPorDia = data.reduce((acc, curr) => {
		const fecha = curr.fecha.slice(0, 10);
		const cobertura = curr.cobertura;

		if (!acc[fecha]) {
			acc[fecha] = { sumaCobertura: 0, conteoHoras: 0 };
		}

		acc[fecha].sumaCobertura += cobertura;
		acc[fecha].conteoHoras += 1;

		return acc;
	}, {});

	const datosFiltrados = Object.entries(coberturaPorDia).map(
		([fecha, { sumaCobertura, conteoHoras }]) => ({
			fecha,
			cobertura: (sumaCobertura / conteoHoras) * 100,
		}),
	);

	const datosFiltradosFecha = datosFiltrados.filter((item) => {
		const fecha = new Date(item.fecha);
		const fechaInicioDate = new Date(fechaInicio);
		const fechaFinDate = new Date(fechaFin);

		return fecha >= fechaInicioDate && fecha <= fechaFinDate;
	});

	return datosFiltradosFecha;
};
// datacharts.js

// datacharts.jsx

function obtenerTotales(data = [], mesesSeleccionados = []) {
	const secciones = ["Diurno", "Nocturno", "Madrugada"];
	let totalNE = 0;
	let totalSP = 0;

	data.forEach((entry) => {
		const contratoMonthly = entry.contrato_monthly || {};
		const outputMonthlyArray = entry.output_planning_monthly || [];

		secciones.forEach((seccion) => {
			(contratoMonthly[seccion] || []).forEach((item) => {
				const salida = outputMonthlyArray.find((o) => o.id === item.output_planning_monthly);
				const mesContrato = salida ? salida.mes : null;
				if (mesContrato != null && mesesSeleccionados.includes(mesContrato)) {
					totalSP += item.contratados_sp || 0;
					totalNE += item.contratados_ne || 0;
				}
			});
		});
	});

	return { totalSP, totalNE };
}

function obtenerTotalCobertura(data = [], mesesSeleccionados = []) {
	let suma = 0,
		conteo = 0;

	data.forEach((entry) => {
		(entry.output_planning_monthly || []).forEach((item) => {
			if (mesesSeleccionados.includes(item.mes)) {
				suma += item.cobertura_media || 0;
				conteo++;
			}
		});
	});

	const promedio = conteo > 0 ? (suma / conteo) * 100 : 0;
	return parseFloat(promedio.toFixed(2));
}

export {
	obtenerDatosTorta,
	obtenerDatosBarras,
	obtenerMesContrato,
	obtenerDiferencias,
	obtenerLogrado,
	obtenerDatosTabla,
	obtenerDatosLinea,
	obtenerDatosLineaFecha,
	obtenerTotales,
	obtenerTotalCobertura,
};
